import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll position to the top on every route change.
 *
 * Mounted once inside <BrowserRouter> in App.js. The effect intentionally
 * depends ONLY on `pathname` so:
 *   - Hash links (#section) within the same page keep working (they don't
 *     trigger a reset).
 *   - Query-string changes on the same route don't cause a scroll jump.
 *
 * Uses `behavior: "auto"` (instant) — smooth scroll on route change feels
 * laggy on most sites.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Some pages might have overridden `scroll-behavior: smooth` at the CSS
    // level; guard against that here by explicitly asking for auto.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch {
      // Older Safari doesn't accept the options object.
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
